export class UpdateProfileFormDto {
  email?: string
  currentPassword?: string
  password?: string
  passwordConfirmation?: string
  babies?: []

  constructor(init?: Partial<UpdateProfileFormDto>) {
    Object.assign(this, init);
  }
}
